export const DPI_MULTIPLIER = 300;
export const STANDARD_MAT_REVEAL = 0.125;
export const OVERSIZE_DIMENSIONS = {
  maxDim: 46,
  minDim: 34
};
export const SHIP_TO_HOME_RESTRICTION_DIMENSIONS = {
  maxDim: 46,
  minDim: 34
};
export const SHIP_TO_HOME_RESTRICTED_SIZE_GROUPS = ["XG", "MG"];

export const IN_STORE_PICKUP_SIZE_GROUPS = ["XG", "MG"];

export default {
  DPI_MULTIPLIER,
  STANDARD_MAT_REVEAL,
  OVERSIZE_DIMENSIONS,
  IN_STORE_PICKUP_SIZE_GROUPS,
  SHIP_TO_HOME_RESTRICTION_DIMENSIONS,
  SHIP_TO_HOME_RESTRICTED_SIZE_GROUPS
};
